import { Privileges } from '../models/privileges';

export class ContrackConstants {
	public static defaultPrivilege: Privileges = {
		dashboard: true,
		admin: false,
		reports: false,
		configuration: false,
		history: false,
		rfp_management: false,
		customer: false,
		add_customer: false,
		view_customer: false,
		edit_customer: false,
		property: false,
		add_property: false,
		add_techspec: false,
		update_techspec: false,
		review_spec: false,
		pdf: false,
		edit_property: false,
		view_property: false,
		assign_property: false,
		assign_vendor_property: false,
		incomplete_questionnaire: false,
		complete_questionnaire: false,
		awarded_contracts: false,
		pending_contracts: false,
		user: false,
		add_user: false,
		edit_user: false,
		view_user: false,
		vendor: false,
		add_vendor: false,
		edit_vendor: false,
		view_vendor: false,
		crew: false,
		add_crew: false,
		edit_crew: false,
		view_crew: false,
		qs_inspection: false,
		qsi_property: false,
		generate_qsi: false,
		view_qsi: false,
		review_qsi: false,
		work_planning: false,
		region_branch: false,
		send_rfp: false,
		received_rfp: false,
		pending_rfp: false,
		generate_rfp: false,
		compare_rfp: false,
		reported_rfp: false,
		review_rfp: false,
		view_rfp_data: false,
		add_plan_material_configuration: false,
		edit_plan_material_configuration: false,
		view_plan_material_configuration: false,
		view_plan_material_configuration_detail: false,
		master_data: false,
		view_history: false,
		adherence_report: false,
		completion_report: false,
		qsi_report: false,
		work_order_report: false,
		privilege: false,
		view_zipcode_specific_configuration: false,
		add_zipcode_specific_configuration: false,
		edit_zipcode_specific_configuration: false,
		zipcode_specific_configuration_detail: false,
		view_rfp_master: false,
		add_rfp_master: false,
		edit_rfp_master: false,
		rfp_master_detail: false,
		view_zone_master: false,
		add_zone_master: false,
		edit_zone_master: false,
		zone_master_detail: false,
		work_order: false,
		property_dashboard: false,
		generate_task: false,
		generate_work_order: false,
		add_work_order: false,
		edit_work_order: false,
		view_work_order: false,
		partially_completed_work_order: false,
		view_data: false,
		completed_services: false,
		unscheduled_services: false,
		incompleted_report: false,
		unscheduledincompleted_report: false,
		extra_work_task: false,
  		add_extra_work_task: false,
  		edit_extra_work_task: false,
  		view_extra_work_task: false,
  		property_extra_work_task: false,
  		scheduledinprogress_report: false,

	};

	public static portalAdminDefaultPrivilege: Privileges = {
		dashboard: true,
		admin: true,
		reports: true,
		configuration: true,
		history: true,
		rfp_management: true,
		customer: true,
		add_customer: true,
		view_customer: true,
		edit_customer: true,
		property: true,
		add_property: true,
		add_techspec: true,
		update_techspec: true,
		review_spec: true,
		pdf: true,
		edit_property: true,
		view_property: true,
		assign_property: true,
		assign_vendor_property: false,
		incomplete_questionnaire: true,
		complete_questionnaire: true,
		awarded_contracts: true,
		pending_contracts: true,
		user: true,
		add_user: true,
		edit_user: true,
		view_user: true,
		vendor: true,
		add_vendor: true,
		edit_vendor: true,
		view_vendor: true,
		crew: false,
		add_crew: false,
		edit_crew: false,
		view_crew: false,
		qs_inspection: true,
		qsi_property: true,
		generate_qsi: true,
		view_qsi: true,
		review_qsi: true,
		work_planning: true,
		region_branch: true,
		send_rfp: true,
		received_rfp: true,
		pending_rfp: false,
		generate_rfp: false,
		compare_rfp: true,
		reported_rfp: false,
		review_rfp: true,
		view_rfp_data: false,
		view_plan_material_configuration: true,
		add_plan_material_configuration: true,
		edit_plan_material_configuration: true,
		view_plan_material_configuration_detail: true,
		master_data: true,
		view_history: true,
		adherence_report: false,
		completion_report: false,
		qsi_report: true,
		work_order_report: false,
		privilege: true,
		view_zipcode_specific_configuration: true,
		add_zipcode_specific_configuration: true,
		edit_zipcode_specific_configuration: true,
		zipcode_specific_configuration_detail: true,
		view_rfp_master: true,
		add_rfp_master: true,
		edit_rfp_master: true,
		rfp_master_detail: true,
		view_zone_master: true,
		add_zone_master: true,
		edit_zone_master: true,
		zone_master_detail: true,
		work_order: false,
		property_dashboard: false,
		generate_task: false,
		generate_work_order: false,
		add_work_order: false,
		edit_work_order: false,
		view_work_order: false,
		partially_completed_work_order: false,
		view_data: true,
		completed_services: true,
		unscheduled_services: true,
		incompleted_report: false,
		unscheduledincompleted_report: false,
		extra_work_task: false,
  		add_extra_work_task: false,
  		edit_extra_work_task: false,
  		view_extra_work_task: false,
  		property_extra_work_task: false,
  		scheduledinprogress_report: false,

	};

	public static customerDefaultPrivilege: Privileges = {
		dashboard: true,
		admin: true,
		reports: true,
		configuration: false,
		history: false,
		rfp_management: true,
		customer: false,
		add_customer: false,
		view_customer: false,
		edit_customer: false,
		property: true,
		add_property: true,
		add_techspec: true,
		update_techspec: true,
		review_spec: true,
		pdf: true,
		edit_property: true,
		view_property: true,
		assign_property: true,
		assign_vendor_property: false,
		incomplete_questionnaire: false,
		complete_questionnaire: false,
		awarded_contracts: false,
		pending_contracts: false,
		user: true,
		add_user: true,
		edit_user: true,
		view_user: true,
		vendor: true,
		add_vendor: true,
		edit_vendor: true,
		view_vendor: true,
		crew: false,
		add_crew: false,
		edit_crew: false,
		view_crew: false,
		qs_inspection: true,
		qsi_property: true,
		generate_qsi: true,
		view_qsi: true,
		review_qsi: true,
		work_planning: true,
		region_branch: true,
		send_rfp: true,
		received_rfp: true,
		pending_rfp: false,
		generate_rfp: false,
		compare_rfp: true,
		reported_rfp: false,
		review_rfp: true,
		view_rfp_data: false,
		add_plan_material_configuration: false,
		edit_plan_material_configuration: false,
		view_plan_material_configuration: false,
		view_plan_material_configuration_detail: false,
		master_data: false,
		view_history: false,
		adherence_report: false,
		completion_report: false,
		qsi_report: true,
		work_order_report: false,
		privilege: false,
		view_zipcode_specific_configuration: false,
		add_zipcode_specific_configuration: false,
		edit_zipcode_specific_configuration: false,
		zipcode_specific_configuration_detail: false,
		view_rfp_master: false,
		add_rfp_master: false,
		edit_rfp_master: false,
		rfp_master_detail: false,
		view_zone_master: false,
		add_zone_master: false,
		edit_zone_master: false,
		zone_master_detail: false,
		work_order: false,
		property_dashboard: false,
		generate_task: false,
		generate_work_order: false,
		add_work_order: false,
		edit_work_order: false,
		view_work_order: false,
		partially_completed_work_order: false,
		view_data: true,
		completed_services: true,
		unscheduled_services: true,
		incompleted_report: false,
		unscheduledincompleted_report: false,
		extra_work_task: false,
  		add_extra_work_task: false,
  		edit_extra_work_task: false,
  		view_extra_work_task: false,
  		property_extra_work_task: false,
  		scheduledinprogress_report: false,

	};

	public static regionalManagerDefaultPrivilege: Privileges = {
		dashboard: true,
		admin: true,
		reports: true,
		configuration: false,
		history: false,
		rfp_management: true,
		customer: false,
		add_customer: false,
		view_customer: false,
		edit_customer: false,
		property: true,
		add_property: true,
		add_techspec: true,
		update_techspec: true,
		review_spec: true,
		pdf: true,
		edit_property: true,
		view_property: true,
		assign_property: true,
		assign_vendor_property: false,
		incomplete_questionnaire: false,
		complete_questionnaire: false,
		awarded_contracts: false,
		pending_contracts: false,
		user: true,
		add_user: true,
		edit_user: true,
		view_user: true,
		vendor: true,
		add_vendor: true,
		edit_vendor: true,
		view_vendor: true,
		crew: false,
		add_crew: false,
		edit_crew: false,
		view_crew: false,
		qs_inspection: true,
		qsi_property: true,
		generate_qsi: true,
		view_qsi: true,
		review_qsi: true,
		work_planning: true,
		region_branch: true,
		send_rfp: true,
		received_rfp: true,
		pending_rfp: false,
		generate_rfp: false,
		compare_rfp: true,
		reported_rfp: false,
		review_rfp: true,
		view_rfp_data: false,
		add_plan_material_configuration: false,
		edit_plan_material_configuration: false,
		view_plan_material_configuration: false,
		view_plan_material_configuration_detail: false,
		master_data: false,
		view_history: false,
		adherence_report: false,
		completion_report: false,
		qsi_report: true,
		work_order_report: false,
		privilege: false,
		view_zipcode_specific_configuration: false,
		add_zipcode_specific_configuration: false,
		edit_zipcode_specific_configuration: false,
		zipcode_specific_configuration_detail: false,
		view_rfp_master: false,
		add_rfp_master: false,
		edit_rfp_master: false,
		rfp_master_detail: false,
		view_zone_master: false,
		add_zone_master: false,
		edit_zone_master: false,
		zone_master_detail: false,
		work_order: false,
		property_dashboard: false,
		generate_task: false,
		generate_work_order: false,
		add_work_order: false,
		edit_work_order: false,
		view_work_order: false,
		partially_completed_work_order: false,
		view_data: true,
		completed_services: true,
		unscheduled_services: true,
		incompleted_report: false,
		unscheduledincompleted_report: false,
		extra_work_task: true,
  		add_extra_work_task: true,
  		edit_extra_work_task: true,
  		view_extra_work_task: true,
  		property_extra_work_task: true,
  		scheduledinprogress_report: true,

	};

	public static branchManagerDefaultPrivilege: Privileges = {
		dashboard: true,
		admin: true,
		reports: true,
		configuration: false,
		history: false,
		rfp_management: true,
		customer: false,
		add_customer: false,
		view_customer: false,
		edit_customer: false,
		property: true,
		add_property: true,
		add_techspec: true,
		update_techspec: true,
		review_spec: true,
		pdf: true,
		edit_property: true,
		view_property: true,
		assign_property: true,
		assign_vendor_property: false,
		incomplete_questionnaire: false,
		complete_questionnaire: false,
		awarded_contracts: false,
		pending_contracts: false,
		user: true,
		add_user: true,
		edit_user: true,
		view_user: true,
		vendor: true,
		add_vendor: true,
		edit_vendor: true,
		view_vendor: true,
		crew: false,
		add_crew: false,
		edit_crew: false,
		view_crew: false,
		qs_inspection: true,
		qsi_property: true,
		generate_qsi: true,
		view_qsi: true,
		review_qsi: true,
		work_planning: true,
		region_branch: false,
		send_rfp: true,
		received_rfp: true,
		pending_rfp: false,
		generate_rfp: false,
		compare_rfp: true,
		reported_rfp: false,
		review_rfp: true,
		view_rfp_data: false,
		add_plan_material_configuration: false,
		edit_plan_material_configuration: false,
		view_plan_material_configuration: false,
		view_plan_material_configuration_detail: false,
		master_data: false,
		view_history: false,
		adherence_report: false,
		completion_report: false,
		qsi_report: true,
		work_order_report: false,
		privilege: false,
		view_zipcode_specific_configuration: false,
		add_zipcode_specific_configuration: false,
		edit_zipcode_specific_configuration: false,
		zipcode_specific_configuration_detail: false,
		view_rfp_master: false,
		add_rfp_master: false,
		edit_rfp_master: false,
		rfp_master_detail: false,
		view_zone_master: false,
		add_zone_master: false,
		edit_zone_master: false,
		zone_master_detail: false,
		work_order: false,
		property_dashboard: false,
		generate_task: false,
		generate_work_order: false,
		add_work_order: false,
		edit_work_order: false,
		view_work_order: false,
		partially_completed_work_order: false,
		view_data: true,
		completed_services: true,
		unscheduled_services: true,
		incompleted_report: false,
		unscheduledincompleted_report: false,
		extra_work_task: true,
  		add_extra_work_task: true,
  		edit_extra_work_task: true,
  		view_extra_work_task: true,
  		property_extra_work_task: true,
  		scheduledinprogress_report: true,

	};

	public static propertyManagerDefaultPrivilege: Privileges = {
		dashboard: true,
		admin: true,
		reports: true,
		configuration: false,
		history: false,
		rfp_management: true,
		customer: false,
		add_customer: false,
		view_customer: false,
		edit_customer: false,
		property: true,
		add_property: true,
		add_techspec: true,
		update_techspec: true,
		review_spec: true,
		pdf: true,
		edit_property: true,
		view_property: true,
		assign_property: false,
		assign_vendor_property: false,
		incomplete_questionnaire: false,
		complete_questionnaire: false,
		awarded_contracts: false,
		pending_contracts: false,
		user: true,
		add_user: true,
		edit_user: true,
		view_user: true,
		vendor: true,
		add_vendor: true,
		edit_vendor: true,
		view_vendor: true,
		crew: false,
		add_crew: false,
		edit_crew: false,
		view_crew: false,
		qs_inspection: true,
		qsi_property: true,
		generate_qsi: true,
		view_qsi: true,
		review_qsi: true,
		work_planning: true,
		region_branch: false,
		send_rfp: true,
		received_rfp: true,
		pending_rfp: false,
		generate_rfp: false,
		compare_rfp: true,
		reported_rfp: false,
		review_rfp: true,
		view_rfp_data: false,
		add_plan_material_configuration: false,
		edit_plan_material_configuration: false,
		view_plan_material_configuration: false,
		view_plan_material_configuration_detail: false,
		master_data: false,
		view_history: false,
		adherence_report: true,
		completion_report: true,
		qsi_report: true,
		work_order_report: true,
		privilege: false,
		view_zipcode_specific_configuration: false,
		add_zipcode_specific_configuration: false,
		edit_zipcode_specific_configuration: false,
		zipcode_specific_configuration_detail: false,
		view_rfp_master: false,
		add_rfp_master: false,
		edit_rfp_master: false,
		rfp_master_detail: false,
		view_zone_master: false,
		add_zone_master: false,
		edit_zone_master: false,
		zone_master_detail: false,
		work_order: true, //change
		property_dashboard: false,
		generate_task: false,
		generate_work_order: false,
		add_work_order: false,
		edit_work_order: false,
		view_work_order: true, //change
		partially_completed_work_order: false,
		view_data: true,
		completed_services: true,
		unscheduled_services: true,
		incompleted_report: true,
		unscheduledincompleted_report: true,
		extra_work_task: true,
  		add_extra_work_task: true,
  		edit_extra_work_task: true,
  		view_extra_work_task: true,
  		property_extra_work_task: true,
  		scheduledinprogress_report: true,

	};

	public static vendorDefaultPrivilege: Privileges = {
		dashboard: true,
		admin: true,  //for Vendor Level region and branch
		reports: true,
		configuration: false,
		history: false,
		rfp_management: true,
		customer: false,
		add_customer: false,
		view_customer: false,
		edit_customer: false,
		property: false,  //added
		add_property: false,
		add_techspec: false,
		update_techspec: false,
		review_spec: false,
		pdf: false,
		edit_property: false,
		view_property: false,
		assign_property: false,
		assign_vendor_property: true, //added
		incomplete_questionnaire: false,
		complete_questionnaire: false,
		awarded_contracts: false,
		pending_contracts: false,
		user: false,
		add_user: false,
		edit_user: false,
		view_user: false,
		vendor: true,  //venden can
		add_vendor: true,   //vender can 
		edit_vendor: true,  //vender can 
		view_vendor: true, //vender can 
		crew: true,
		add_crew: true,
		edit_crew: true,
		view_crew: true,
		qs_inspection: true,//changes
		qsi_property: false,
		generate_qsi: false,
		view_qsi: false,
		review_qsi: true,
		work_planning: false,
		region_branch: true,
		send_rfp: false,
		received_rfp: false,
		pending_rfp: true,
		generate_rfp: true,
		compare_rfp: false,
		reported_rfp: true,
		review_rfp: false,
		view_rfp_data: true,
		add_plan_material_configuration: false,
		edit_plan_material_configuration: false,
		view_plan_material_configuration: false,
		view_plan_material_configuration_detail: false,
		master_data: false,
		view_history: false,
		adherence_report: true,
		completion_report: true,
		qsi_report: true,
		work_order_report: false,
		privilege: false,
		view_zipcode_specific_configuration: false,
		add_zipcode_specific_configuration: false,
		edit_zipcode_specific_configuration: false,
		zipcode_specific_configuration_detail: false,
		view_rfp_master: false,
		add_rfp_master: false,
		edit_rfp_master: false,
		rfp_master_detail: false,
		view_zone_master: false,
		add_zone_master: false,
		edit_zone_master: false,
		zone_master_detail: false,
		work_order: true,
		property_dashboard: true,
		generate_task: true,
		generate_work_order: true,
		add_work_order: true,
		edit_work_order: true,
		view_work_order: true,
		partially_completed_work_order: true,
		view_data: false,
		completed_services: false,
		unscheduled_services: false,
		incompleted_report: true,
		unscheduledincompleted_report: true,
		extra_work_task: true,
  		add_extra_work_task: true,
  		edit_extra_work_task: true,
  		view_extra_work_task: true,
  		property_extra_work_task: true,
  		scheduledinprogress_report: true,

	};

	public static regionalManagerVendorDefaultPrivilege: Privileges = {
		dashboard: true,
		admin: true,  //for Vendor Level region and branch
		reports: true,
		configuration: false,
		history: false,
		rfp_management: true,
		customer: false,
		add_customer: false,
		view_customer: false,
		edit_customer: false,
		property: false,
		add_property: false,
		add_techspec: false,
		update_techspec: false,
		review_spec: false,
		pdf: false,
		edit_property: false,
		view_property: false,
		assign_property: false,
		assign_vendor_property: true,
		incomplete_questionnaire: false,
		complete_questionnaire: false,
		awarded_contracts: false,
		pending_contracts: false,
		user: false,
		add_user: false,
		edit_user: false,
		view_user: false,
		vendor: true,  //venden can
		add_vendor: true,   //vender can 
		edit_vendor: true,  //vender can 
		view_vendor: true, //vender can 
		crew: true,
		add_crew: true,
		edit_crew: true,
		view_crew: true,
		qs_inspection: true,//changes
		qsi_property: false,
		generate_qsi: false,
		view_qsi: false,
		review_qsi: true,
		work_planning: false,
		region_branch: false, //changes
		send_rfp: false,
		received_rfp: false,
		pending_rfp: true,
		generate_rfp: true,
		compare_rfp: false,
		reported_rfp: true,
		review_rfp: false,
		view_rfp_data: true,
		add_plan_material_configuration: false,
		edit_plan_material_configuration: false,
		view_plan_material_configuration: false,
		view_plan_material_configuration_detail: false,
		master_data: false,
		view_history: false,
		adherence_report: true,
		completion_report: true,
		qsi_report: true,
		work_order_report: false,
		privilege: false,
		view_zipcode_specific_configuration: false,
		add_zipcode_specific_configuration: false,
		edit_zipcode_specific_configuration: false,
		zipcode_specific_configuration_detail: false,
		view_rfp_master: false,
		add_rfp_master: false,
		edit_rfp_master: false,
		rfp_master_detail: false,
		view_zone_master: false,
		add_zone_master: false,
		edit_zone_master: false,
		zone_master_detail: false,
		work_order: true,
		property_dashboard: true,
		generate_task: true,
		generate_work_order: true,
		add_work_order: true,
		edit_work_order: true,
		view_work_order: true,
		partially_completed_work_order: true,
		view_data: false,
		completed_services: false,
		unscheduled_services: false,
		incompleted_report: true,
		unscheduledincompleted_report: true,
		extra_work_task: true,
  		add_extra_work_task: true,
  		edit_extra_work_task: true,
  		view_extra_work_task: true,
  		property_extra_work_task: true,
  		scheduledinprogress_report: true,

	};


	public static branchManagerVendorDefaultPrivilege: Privileges = {
		dashboard: true,
		admin: true,  //for Vendor Level region and branch
		reports: true,
		configuration: false,
		history: false,
		rfp_management: true,
		customer: false,
		add_customer: false,
		view_customer: false,
		edit_customer: false,
		property: false,
		add_property: false,
		add_techspec: false,
		update_techspec: false,
		review_spec: false,
		pdf: false,
		edit_property: false,
		view_property: false,
		assign_property: false,
		assign_vendor_property: true,
		incomplete_questionnaire: false,
		complete_questionnaire: false,
		awarded_contracts: false,
		pending_contracts: false,
		user: false,
		add_user: false,
		edit_user: false,
		view_user: false,
		vendor: true,  //venden can
		add_vendor: true,   //vender can 
		edit_vendor: true,  //vender can 
		view_vendor: true, //vender can 
		crew: true,
		add_crew: true,
		edit_crew: true,
		view_crew: true,
		qs_inspection: true,//changes
		qsi_property: false,
		generate_qsi: false,
		view_qsi: false,
		review_qsi: true,
		work_planning: false,
		region_branch: false, //changes
		send_rfp: false,
		received_rfp: false,
		pending_rfp: true,
		generate_rfp: true,
		compare_rfp: false,
		reported_rfp: true,
		review_rfp: false,
		view_rfp_data: true,
		add_plan_material_configuration: false,
		edit_plan_material_configuration: false,
		view_plan_material_configuration: false,
		view_plan_material_configuration_detail: false,
		master_data: false,
		view_history: false,
		adherence_report: true,
		completion_report: true,
		qsi_report: true,
		work_order_report: false,
		privilege: false,
		view_zipcode_specific_configuration: false,
		add_zipcode_specific_configuration: false,
		edit_zipcode_specific_configuration: false,
		zipcode_specific_configuration_detail: false,
		view_rfp_master: false,
		add_rfp_master: false,
		edit_rfp_master: false,
		rfp_master_detail: false,
		view_zone_master: false,
		add_zone_master: false,
		edit_zone_master: false,
		zone_master_detail: false,
		work_order: true,
		property_dashboard: true,
		generate_task: true,
		generate_work_order: true,
		add_work_order: true,
		edit_work_order: true,
		view_work_order: true,
		partially_completed_work_order: true,
		view_data: false,
		completed_services: false,
		unscheduled_services: false,
		incompleted_report: true,
		unscheduledincompleted_report: true,
		extra_work_task: true,
  		add_extra_work_task: true,
  		edit_extra_work_task: true,
  		view_extra_work_task: true,
  		property_extra_work_task: true,
  		scheduledinprogress_report: true,

	};


	public static localVendorDefaultPrivilege: Privileges = {
		dashboard: true,
		admin: true,  //for Vendor Level region and branch
		reports: true,
		configuration: false,
		history: false,
		rfp_management: true,
		customer: false,
		add_customer: false,
		view_customer: false,
		edit_customer: false,
		property: false,
		add_property: false,
		add_techspec: false,
		update_techspec: false,
		review_spec: false,
		pdf: false,
		edit_property: false,
		view_property: false,
		assign_property: false,
		assign_vendor_property: false,
		incomplete_questionnaire: false,
		complete_questionnaire: false,
		awarded_contracts: false,
		pending_contracts: false,
		user: false,
		add_user: false,
		edit_user: false,
		view_user: false,
		vendor: true,  //venden can
		add_vendor: true,   //vender can 
		edit_vendor: true,  //vender can 
		view_vendor: true, //vender can 
		crew: true,
		add_crew: true,
		edit_crew: true,
		view_crew: true,
		qs_inspection: true,//changes
		qsi_property: false,
		generate_qsi: false,
		view_qsi: false,
		review_qsi: true,
		work_planning: false,
		region_branch: false, //changes
		send_rfp: false,
		received_rfp: false,
		pending_rfp: true,
		generate_rfp: true,
		compare_rfp: false,
		reported_rfp: true,
		review_rfp: false,
		view_rfp_data: true,
		add_plan_material_configuration: false,
		edit_plan_material_configuration: false,
		view_plan_material_configuration: false,
		view_plan_material_configuration_detail: false,
		master_data: false,
		view_history: false,
		adherence_report: true,
		completion_report: true,
		qsi_report: true,
		work_order_report: false,
		privilege: false,
		view_zipcode_specific_configuration: false,
		add_zipcode_specific_configuration: false,
		edit_zipcode_specific_configuration: false,
		zipcode_specific_configuration_detail: false,
		view_rfp_master: false,
		add_rfp_master: false,
		edit_rfp_master: false,
		rfp_master_detail: false,
		view_zone_master: false,
		add_zone_master: false,
		edit_zone_master: false,
		zone_master_detail: false,
		work_order: true,
		property_dashboard: true,
		generate_task: true,
		generate_work_order: true,
		add_work_order: true,
		edit_work_order: true,
		view_work_order: true,
		partially_completed_work_order: true,
		view_data: false,
		completed_services: false,
		unscheduled_services: false,
		incompleted_report: true,
		unscheduledincompleted_report: true,
		extra_work_task: true,
  		add_extra_work_task: true,
  		edit_extra_work_task: true,
  		view_extra_work_task: true,
  		property_extra_work_task: true,
  		scheduledinprogress_report: true,

	};

	public static readonly dateFormatForInput: string = 'yyyy-MM-dd';
}
